import Marionette from "../../../shared/marionette-mustache";
import { FullTextSourceModel } from "../../../desktop/models/full-text-source";
import { AuthorizationModel } from "../../../authentication/models/authorization-model";
import { AppSettings } from "../../../app-settings";
import { backboneViewProperties } from "../../../decorators/backbone-properties";
import {AppEvents} from "../../../app-events";
import {Container} from "aurelia-dependency-injection";
import { ContainerHelper } from "../../../shared/helpers/container-helper";

const template = require<string>("../../../desktop/views/partials/parallel-citation-link.html");

@backboneViewProperties({
    tagName: "div",
    template,
    className: "full-text-link"
})
export class FullTextLinkRelationView extends Marionette.ItemView<FullTextSourceModel> {

    constructor(options?: Backbone.ViewOptions<FullTextSourceModel>) {
        super(options);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click a"] = (e) => this.logClick(e);
        return events;
    }

    public logClick(e: Event) {
        try {
            const target = $(e.currentTarget);
            const imageElement =  target.find("img");

            const citation: string = target.parents(".js-parallel-citation").data("reference");
            const title: string = (imageElement !== null) ? imageElement.attr("title") : "";
            const siteId: string = (imageElement !== null) ? imageElement.data("site-id") : "";
            const url: string = target.attr("href");

            ContainerHelper.Events.trigger(AppEvents.AppInsightsDocumentSourcesGotoLink, {
                Citation: citation,
                Title: title,
                Url: url,
                SiteId: siteId
            });

            $.ajax({
                    url: AppSettings.ApiUrlPrefix + "logging/Log",
                    beforeSend: AuthorizationModel.attachAuthorizationHeader,
                    method: "POST",
                    cache: false,
                    data: {
                        name: citation + " at " + title,
                        url: url,
                        siteId: siteId
                    }
                });
        } catch (e) {
            // dev.log("Error logging multilink click: " + e);
        }
    }

    public initialize(): void {
        // needed to extend the class name dynamically with info from the model
        if (!this.model.DisplayLink) {
            this.$el.addClass("deactivated");
        } else if (this.model.AllAreHidden) {
            // this is just the message to say that all links are hidden
            this.$el.addClass("all-hidden-msg");
        } else if (this.model.NoLinks) {
            this.$el.addClass("no-links");
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/full-text-link-relation.ts